export default (theme) => ({
  logoWrapper: {
    height: 'auto',
    maxWidth: 320,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: 0,
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      paddingLeft: 24,
      justifyContent: 'center',
    },
  },
  logo: {
    width: 60,
    height: 'auto',
    maxHeight: 60,
    objectFit: 'contain',
    objectPosition: 'center',
    [theme.breakpoints.down('md')]: {
      width: 50,
      maxHeight: 50,
    },
    [theme.breakpoints.down('sm')]: {
      width: 40,
      maxHeight: 40,
    },
  },
  orgName: {
    fontSize: 25,
    fontWeight: 'bold',
    color: 'black',
    marginLeft: 20,
    maxHeight: 60,
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 2,
    wordBreak: 'break-word',
    overflow: 'hidden',
    [theme.breakpoints.down('ml')]: {
      marginLeft: 10,
      fontSize: 22,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
});
